import { ensureJqueryEl } from "./helpers";

export class BasicImageGallery {
    /**
     * @private
     * @param {jQuery} $container - The jQuery object for the root gallery container.
     */
    constructor($container) {
        // Enforce the use of getInstance() to create new instances.
        if ($container.data('BasicImageGallery')) {
            throw new Error("BasicImageGallery: Use getInstance() to get or create an instance.");
        }

        this.$container = $container;
        this.$featuredImage = this.$container.find('.js-featured-image');
        this.$thumbnailsContainer = this.$container.find('.js-thumbnails-container');

        if (this.$featuredImage.length && this.$thumbnailsContainer.length) {
            this.bindEvents();
        } else {
            console.warn("BasicImageGallery: Missing required elements in the container.");
        }
    }

    /**
     * @static
     * @method getInstance
     * @description Gets or creates a single instance of BasicImageGallery for a given container.
     * @param {HTMLElement|jQuery|string} containerEl - The gallery's root container.
     * @returns {BasicImageGallery|undefined} The new or existing instance.
     */
    static getInstance(containerEl) {
        const $container = ensureJqueryEl(containerEl);

        if (!$container.length) {
            console.warn("BasicImageGallery: Container element not found.");
            return;
        }

        let instance = $container.data('BasicImageGallery');

        if (!instance) {
            instance = new BasicImageGallery($container);
            $container.data('BasicImageGallery', instance);
        }

        return instance;
    }

    /**
     * Binds all event listeners for the component's interactive elements.
     * @private
     */
    bindEvents() {
        this.$thumbnailsContainer.on('click keydown', '.js-thumbnail', (event) => {
            if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
                event.preventDefault();

                const $clickedThumbnail = $(event.currentTarget);
                const fullImageUrl = $clickedThumbnail.data('full-image-src');
                const altText = $clickedThumbnail.attr('alt');

                if (fullImageUrl) {
                    this.$featuredImage.attr('src', fullImageUrl);
                    this.$featuredImage.attr('alt', altText);

                    this.$thumbnailsContainer.find('.js-thumbnail.active').removeClass('active').attr('aria-current', 'false');
                    $clickedThumbnail.addClass('active').attr('aria-current', 'true');
                }
            }
        });
    }
}

const initBasicImageGallery = (containerEl) => {
    BasicImageGallery.getInstance(containerEl);
}
export default initBasicImageGallery;